import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    constructor(private messageService: MessageService) {}

    showSuccess(summary: string, sticky: boolean = false, detail?: string) {
        this.messageService.add({
            sticky,
            severity: 'success',
            summary: summary,
            detail: detail,
        });
    }

    showError(summary: string, sticky: boolean = false, detail?: string) {
        this.messageService.add({
            severity: 'error',
            summary: summary,
            detail: detail,
        });
    }

    showInfo(summary: string, sticky: boolean = false, detail?: string) {
        this.messageService.add({
            severity: 'info',
            summary: summary,
            detail: detail,
        });
    }

    showWarn(summary: string, sticky: boolean = false, detail?: string) {
        this.messageService.add({
            severity: 'warn',
            summary: summary,
            detail: detail,
        });
    }
}
